import React from "react";

export default function Brand({ size = "md" }) {
  const dims = size === "lg" ? "w-12 h-12" : size === "sm" ? "w-8 h-8" : "w-10 h-10";
  return (
    <div className="flex items-center gap-3">
      <img src="/logo.png" alt="Vyapar CRM" className={`${dims} rounded-lg object-cover bg-white p-0.5 border border-border`} />
      <div>
        <div className="font-heading font-bold text-base leading-none tracking-tight">Vyapar CRM</div>
        <div className="text-[10px] text-muted-foreground mt-1 tracking-[0.2em] uppercase">Connect · Manage · Grow</div>
      </div>
    </div>
  );
}
